// src/components/Leave/LeaveTabsNav.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FileText, Users, CheckCircle, Award, Settings, ClipboardList, WalletCards
} from 'lucide-react';

const LEAVE_TABS = [
  { id: 'request', label: 'Leave Request', icon: FileText, path: '/hrm/leave/request' },
  { id: 'approval', label: 'Leave Approval', icon: CheckCircle, path: '/hrm/leave/approval' },
  // { id: 'earnings', label: 'Leave Earnings', icon: Award, path: '/hrm/leave/earnings' },
  { id: 'allocation', label: 'Leave Allocation', icon: Users, path: '/hrm/leave/allocation' },
  { id: 'balance', label: 'Leave Balance', icon: WalletCards, path: '/hrm/leave/balance' },
];

export default function LeaveTabsNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabClick = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-4 overflow-x-auto" aria-label="Tabs">
        {LEAVE_TABS.map((tab) => {
          const active = isActive(tab.path);
          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.path)}
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-all whitespace-nowrap
                ${active
                  ? 'border-green-800 text-green-800'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              <tab.icon size={18} className={active ? 'text-green-600' : 'text-gray-400'} />
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}